import { Container } from '@components/Container'
import { Loading } from '@components/Loading'
import { formatDateDomini } from '@lib/utils'
import { SearchEbookSaleAnalytics } from '../SaleAnalyticsTab/components/SearchEbookSaleAnalytics'
import { EbookOverviewTabs } from './components/EbookOverviewTabs'
import { EbookSaleAnalyticsDetail } from './components/EbookSaleAnalyticsDetail'
import { EbookSaleAnalyticsOverviewProps } from './interface'

export function EbookSaleAnalyticsOverview({
  initialValues,
  data,
  isLoading,
  startDate,
  endDate,
  queryParams,
  handleSearch,
}: EbookSaleAnalyticsOverviewProps) {
  return (
    <Container>
      <div className='grid gap-y-[20px]'>
        <SearchEbookSaleAnalytics
          queryParams={queryParams}
          initialValues={initialValues}
          handleSubmit={handleSearch}
        />
        <hr className='w-full border-t border-gray-3 dark:border-purple' />
        <div>
          <div className='font-light text-[14px] text-secondary-1 mb-[30px] tablet-mobile:mb-[20px]'>
            {`ข้อมูล ณ วันที่ ${formatDateDomini(
              startDate.toString(),
              false
            )} - ${formatDateDomini(endDate.toString(), false)}`}
          </div>
        </div>
      </div>
      <EbookSaleAnalyticsDetail
        totalSales={data?.sales || 0}
        buyCount={data?.purchasedCount || 0}
        viewCount={data?.viewCount || 0}
        preReadCount={data?.readTrialChapterCount || 0}
        ebookId={queryParams.ebookId}
      />
      <EbookOverviewTabs queryParams={queryParams} />
    </Container>
  )
}
